import { toDbId } from "~/utils/graphql-helpers";
import { RoleObjectType } from "./TestAnnouncementCard";
import { FormValues } from "./types";

export const toCamelCase = (str: string) => {
  str = str.replace(/\s*\(\s*|\s*\)\s*/g, ""); // Remove the parentheses but keep the content
  str = str.replace(/-/g, ""); // Remove hyphens

  // Check if the string starts with "CAN"
  if (str.startsWith("CAN")) {
    // Remove "CAN" and underscores, and then lowerCase the rest
    return str
      .replace(/^CAN_/, "") // Remove "CAN_"
      .replace(/_(.)/g, (_, char) => char.toUpperCase()) // Convert underscores to camel case
      .toLowerCase(); // Ensure everything is lowercase
  }

  // General camel case handling
  return str
    .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) =>
      index === 0 ? match.toLowerCase() : match.toUpperCase(),
    )
    .replace(/\s+/g, "");
};

export const getGrantedRoles = (
  camelCasedRoles: RoleObjectType,
  manageStaffAccessSettingRoles: RoleObjectType,
  manageBasicSettingRoles: RoleObjectType,
  manageAdminConfigurationRoles: RoleObjectType,
  isObjectLevelBasicPermissionSettingsRoles: RoleObjectType,
  values: FormValues,
) => {
  const grantedRoleIds = (camelCasedRoles ?? [])
    .filter((role) => {
      return values[role.name as keyof FormValues] === true;
    })
    .map((role) => role.id);

  // add basic object level permission setting roles
  if (values.isObjectLevelBasicPermissionRole && isObjectLevelBasicPermissionSettingsRoles) {
    const additionalRoleIds = isObjectLevelBasicPermissionSettingsRoles.map((role) => role.id);
    grantedRoleIds.push(...additionalRoleIds);
  }

  // add manage admin configuration setting roles
  if (values.isManageAdminConfigurationSettingRole && manageAdminConfigurationRoles) {
    const additionalRoleIds = manageAdminConfigurationRoles.map((role) => role.id);
    grantedRoleIds.push(...additionalRoleIds);
  }

  // add manage staff access roles
  if (values.isManageStaffAccessSettingRole && manageStaffAccessSettingRoles) {
    const additionalRoleIds = manageStaffAccessSettingRoles.map((role) => role.id);
    grantedRoleIds.push(...additionalRoleIds);
  }

  // add manage basic access roles
  if (values.isManageBasicSettingRole && manageBasicSettingRoles) {
    const additionalRoleIds = manageBasicSettingRoles.map((role) => role.id);
    grantedRoleIds.push(...additionalRoleIds);
  }
  return grantedRoleIds.map((id) => toDbId(id));
};
